export const DROPSHIP_STARTS_FROM = 'dropship_starts_from_text';
export const DROPSHIP_STARTING_AT = 'dropship_starting_at_text';
